import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import type { SiffletColors } from '@/plugins/theme';

export type IconSize = 'x-small' | 'small' | 'default' | 'large' | 'x-large';

export interface SIconComposerProps {
  icon: string,
  imageSrc?: string,
  alt?: string,
  iconColor?: SiffletColors,
  size?: IconSize;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SIconComposer',
  props: {
  icon: null,
  imageSrc: { default: '/images/datasources/light/undefined.svg' },
  alt: null,
  iconColor: { default: 'textPrimary' },
  size: { default: 'default' }
},
  setup(__props) {

const props = __props;
const SIZES_IN_PIXEL: Record<IconSize, number> = {
  'x-small': 12,
  small: 16,
  default: 20,
  large: 24,
  'x-large': 32,
};



const sizeInPixels = _computed(() => SIZES_IN_PIXEL[props.size]);

const style = _computed(() => ({
  width: `${sizeInPixels.value}px`,
  height: `${sizeInPixels.value}px`,
}));

const iconStyle = _computed(() => {
  const baseSize = SIZES_IN_PIXEL[props.size];
  const scale = baseSize / SIZES_IN_PIXEL.large;

  return {
    top: `${35 * scale}%`,
    left: `${35 * scale}%`,
    transform: `scale(${0.6 * scale})`,
  };
});


return { __sfc: true,SIZES_IN_PIXEL, props, sizeInPixels, style, iconStyle, _computed }
}

})